jQuery(document).ready(function ($) {
	if($('.module-decision-tree-scope').length){
		
		// DOM-Elements
		$ctn_questions = $('.component-decision-tree-questions>.component-inner');
		$ctn_question = $('.component-decision-tree-question');
		$ctn_display = $('.component-decision-tree-display>.component-inner');
		$ctn_display_breadcrumb = $('.component-decision-tree-breadcrumb>.component-inner');
		$ctn_results = $('.component-decision-tree-results>.component-inner');

		// Content
		$breadcrumb_content_arr = [];
		$breadcrumb_content_arr['min-age'] = ['Alter'];
		
		var set_active_question = function(){
			// first init
			$ctn_question.attr('data-question-state', 'invisible');
			$ctn_question.first().attr('data-question-state', 'active');

			set_active_function();
		};

		var set_active_function = function(){
			$targetElement = $('[data-question-state="active"]');
			if($targetElement.attr('data-question-type') == 'button'){
				$button = $targetElement.find('[data-answer]');
				$target = $button;
			} else if($targetElement.attr('data-question-type') == 'number'){
				$button = $targetElement.find(':submit');
				$target = $targetElement.find('input[type="number"]');
			}

			$button.on('click', function(){
				check_min_age($target.val());
			});
		}

		var check_min_age = function(min_age_value){
			results_arr = find_active_results(min_age_value, 'min-age');
			display_results(results_arr, 'min-age');
		};

		var find_active_results = function(value, comparator){
			var result = [];
			var result_active_arr = [];
			var result_inactive_arr = [];
			
			$ctn_results.find('.component-decision-tree-result-card').each(function(){
				result_inactive_arr.push($(this).attr('data-id')); // collect all ids
				switch(comparator){
					case 'min-age':
						result_active_arr = comparator_min_age(this, value, result_active_arr);
					break;
				}
			});
			// remove active ids from inactive array
			result_inactive_arr = $(result_inactive_arr).not(result_active_arr).get();
			result = [result_active_arr, result_inactive_arr];
			return result;
		};

		var comparator_min_age = function(element, min_age, result_active_arr){
			if($(element).attr('data-min-age') <= min_age){
				result_active_arr.push($(element).attr('data-id'));
			}
			return result_active_arr;
		};

		var show_errors = function(result_active_arr){
			if(result_active_arr.length === 0){
				error_no_results();
			} else{
				$ctn_results.find('.dt-error').remove();
			}
		};

		var filter_results = function(result_active_arr, result_inactive_arr){
			$.each(result_inactive_arr, function(index, value){
				$('.element-class-icon[data-id="'+value+'"]').attr('data-state', 'inactive');
				$('.component-decision-tree-result-card[data-id="'+value+'"]').fadeOut(500);
			});
			$.each(result_active_arr, function(index, value){
				$('.element-class-icon[data-id="'+value+'"]').attr('data-state', 'active');
				$('.component-decision-tree-result-card[data-id="'+value+'"]').fadeIn(500);
			});
		};

		var display_results = function(results_arr, step){
			filter_results(results_arr[0], results_arr[1]);
			show_errors(results_arr[0]);
			// form_elements_update();
			//breadcrumb_update(step);
		};

		var form_elements_update = function(){
			// Formular Felder aktualisieren
		};

		var breadcrumb_update = function(step){
			$ctn_display_breadcrumb.append('<div data-question="'+0+'">'+$breadcrumb_content_arr[step]+'</div>');
		};

		var error_no_results = function(){
			$ctn_results.find('.dt-error').remove();
			$ctn_results.append('<div class="dt-error"><p>Es wurden keine Ergebnisse gefunden.</p></div>');
			setTimeout(function(){
				$('.dt-error').css('opacity', 1);
			},500);
		};
	
		var init = function(){
			$q_active = $ctn_question.find(['data-question-state="active"']);
			set_active_question();
		}
	
		init();

	}
});